import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import { Container, Row, Col } from 'reactstrap';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

const styles = StyleSheet.create({
    slide: {
        height: '200px',
        width: '100%',
        backgroundColor: '#fff'
    },
    photo: {
        height: '80px',
        width: '80px',
        position: 'absolute',
        left: '5px',
        top: '5px'
    },
    quote: {
        '@media (min-width: 800px)': {
            fontSize: '20px'
        }
    },
    star: {
        color: '#FFDF00',
        '@media (min-width: 800px)': {
            fontSize: '20px'
        }
    },
    user: {
        float: "right",
        '@media (min-width: 800px)': {
            fontSize: '20px'
        }
    },
    anchorNoStyling: {
        color: 'inherit',
        textDecoration: 'inherit'
    }
});


class TestimonialItem extends Component {

    getRatingStars = (rating) => {
        var stars = []
        for (let index = 0; index < rating; index++) {
            stars.push(<FaStar className={css(styles.star)} />)
        }
        return stars
    }

    render() {
        return (
            <a className={css(styles.anchorNoStyling)} href="https://bit.ly/mubit-opiniones" target="_blank">
                <div className={css(styles.slide) + " p-3 d-flex align-items-center"}>
                    <img className={css(styles.photo) + " lazyload"} data-src={this.props.photo} alt="Foto de Usuario de google" />
                    <Container fluid>
                        <Row>
                            <Col xs={2} lg={2}>

                            </Col>
                            <Col xs={10} lg={10}>
                                <p className={css(styles.quote) + ""}>{this.props.quote}</p>
                                <div className="float-left">{this.getRatingStars(this.props.rating)}</div>
                                <footer className={css(styles.user) + " blockquote-footer float-right"}>{this.props.username}</footer>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </a>
        );
    }
}

export default TestimonialItem;
